import * as angular from "angular";

angular
  .module('bringoz.admin.self-pickups')
  .config(selfPickupsConfig);

/* @ngInject */
function selfPickupsConfig($stateProvider) {

  $stateProvider

    // Self Pickup Main
    .state('self-pickups', {
      parent: 'bringoz.site',
      url: '/self-pickups',
      params: {
        depotId: undefined
      },
      template: '<ui-view></ui-view>',
      abstract: true
    })

    // Self Pickup List
    .state('self-pickups.active', {
      url: '/active?depotId',
      template: '<self-pickups-view depot="vm.depot" is-active-view="true"></self-pickups-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, $state, depots) {

        this.depot = depots[0];

        if (!this.depot) {
          $state.go('^.no-depots');
          return;
        }

        if (!$stateParams.depotId) {
          $state.go('.', {depotId: this.depot.id}, {notify: true, reload: false, location: 'replace'});
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Active'});
        triBreadcrumbsService.addCrumb({name: 'Self Pickups'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      },
      resolve: {
        depotIds: function ($depots, $stateParams, $q, site) {
          var depotsRef = $depots(),
            depotId = $stateParams.depotId;

          return depotId ? $q.when([depotId]) : depotsRef.$getAll({limit: 1});
        },
        depots: function ($depots, depotIds, site) {
          return $depots().$asyncValues(depotIds);
        }
      }
    })

    // Self Pickup List - Israel Post POC (mock data only)
    .state('self-pickups.pms', {
      url: '/pms?depotId',
      template: '<israel-post-view depot="vm.depot"></israel-post-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, depots) {

        this.depot = depots[0];

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Parcel Management System'});
        triBreadcrumbsService.addCrumb({name: 'Self Pickups'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      },
      resolve: {
        depotIds: function ($depots, $stateParams, $q, site) {
          var depotsRef = $depots(),
            depotId = $stateParams.depotId;

          return depotId ? $q.when([depotId]) : depotsRef.$getAll({limit: 1});
        },
        depots: function ($depots, depotIds, site) {
          return $depots().$asyncValues(depotIds);
        }
      }
    })

    .state('self-pickups.inactive', {
      url: '/closed?depotId',
      template: '<self-pickups-view depot="vm.depot" is-active-view="false"></self-pickups-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, $state, depots) {

        this.depot = depots[0];

        if (!this.depot) {
          $state.go('^.no-depots');
          return;
        }

        if (!$stateParams.depotId) {
          $state.go('.', {depotId: this.depot.id}, {notify: true, reload: false, location: 'replace'});
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Closed'});
        triBreadcrumbsService.addCrumb({name: 'Self Pickups'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      },
      resolve: {
        depotIds: function ($depots, $stateParams, $q, site) {
          var depotsRef = $depots(),
            depotId = $stateParams.depotId;

          return depotId ? $q.when([depotId]) : depotsRef.$getAll({limit: 1});
        },
        depots: function ($depots, depotIds, site) {
          return $depots().$asyncValues(depotIds);
        }
      }
    })

    .state('self-pickups.no-depots', {
      url: '/no-depots',
      template: '<self-pickups-view-no-depots></self-pickups-view-no-depots>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'No Depots'});
        triBreadcrumbsService.addCrumb({name: 'Self Pickups'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })

}
